(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // node_modules/crypt/crypt.js
  var require_crypt = __commonJS({
    "node_modules/crypt/crypt.js"(exports, module) {
      (function () {
        var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt = {
          // Bit-wise rotation left
          rotl: function (n, b) {
            return n << b | n >>> 32 - b;
          },
          // Bit-wise rotation right
          rotr: function (n, b) {
            return n << 32 - b | n >>> b;
          },
          // Swap big-endian to little-endian and vice versa
          endian: function (n) {
            if (n.constructor == Number) {
              return crypt.rotl(n, 8) & 16711935 | crypt.rotl(n, 24) & 4278255360;
            }
            for (var i = 0; i < n.length; i++)
              n[i] = crypt.endian(n[i]);
            return n;
          },
          // Generate an array of any length of random bytes
          randomBytes: function (n) {
            for (var bytes = []; n > 0; n--)
              bytes.push(Math.floor(Math.random() * 256));
            return bytes;
          },
          // Convert a byte array to big-endian 32-bit words
          bytesToWords: function (bytes) {
            for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
              words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
          },
          // Convert big-endian 32-bit words to a byte array
          wordsToBytes: function (words) {
            for (var bytes = [], b = 0; b < words.length * 32; b += 8)
              bytes.push(words[b >>> 5] >>> 24 - b % 32 & 255);
            return bytes;
          },
          // Convert a byte array to a hex string
          bytesToHex: function (bytes) {
            for (var hex = [], i = 0; i < bytes.length; i++) {
              hex.push((bytes[i] >>> 4).toString(16));
              hex.push((bytes[i] & 15).toString(16));
            }
            return hex.join("");
          },
          // Convert a hex string to a byte array
          hexToBytes: function (hex) {
            for (var bytes = [], c = 0; c < hex.length; c += 2)
              bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
          },
          // Convert a byte array to a base-64 string
          bytesToBase64: function (bytes) {
            for (var base64 = [], i = 0; i < bytes.length; i += 3) {
              var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
              for (var j = 0; j < 4; j++)
                if (i * 8 + j * 6 <= bytes.length * 8)
                  base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 63));
                else
                  base64.push("=");
            }
            return base64.join("");
          },
          // Convert a base-64 string to a byte array
          base64ToBytes: function (base64) {
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
            for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
              if (imod4 == 0)
                continue;
              bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
          }
        };
        module.exports = crypt;
      })();
    }
  });

  // node_modules/charenc/charenc.js
  var require_charenc = __commonJS({
    "node_modules/charenc/charenc.js"(exports, module) {
      var charenc = {
        // UTF-8 encoding
        utf8: {
          // Convert a string to a byte array
          stringToBytes: function (str) {
            return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
          },
          // Convert a byte array to a string
          bytesToString: function (bytes) {
            return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
          }
        },
        // Binary encoding
        bin: {
          // Convert a string to a byte array
          stringToBytes: function (str) {
            for (var bytes = [], i = 0; i < str.length; i++)
              bytes.push(str.charCodeAt(i) & 255);
            return bytes;
          },
          // Convert a byte array to a string
          bytesToString: function (bytes) {
            for (var str = [], i = 0; i < bytes.length; i++)
              str.push(String.fromCharCode(bytes[i]));
            return str.join("");
          }
        }
      };
      module.exports = charenc;
    }
  });

  // node_modules/is-buffer/index.js
  var require_is_buffer = __commonJS({
    "node_modules/is-buffer/index.js"(exports, module) {
      /*!
       * Determine if an object is a Buffer
       *
       * @author   Feross Aboukhadijeh <https://feross.org>
       * @license  MIT
       */
      module.exports = function (obj) {
        return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
      };
      function isBuffer(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
      }
      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer(obj.slice(0, 0));
      }
    }
  });

  // node_modules/md5/md5.js
  var require_md5 = __commonJS({
    "node_modules/md5/md5.js"(exports, module) {
      (function () {
        var crypt = require_crypt(), utf8 = require_charenc().utf8, isBuffer = require_is_buffer(), bin = require_charenc().bin, md52 = function (message, options) {
          if (message.constructor == String)
            if (options && options.encoding === "binary")
              message = bin.stringToBytes(message);
            else
              message = utf8.stringToBytes(message);
          else if (isBuffer(message))
            message = Array.prototype.slice.call(message, 0);
          else if (!Array.isArray(message) && message.constructor !== Uint8Array)
            message = message.toString();
          var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
          for (var i = 0; i < m.length; i++) {
            m[i] = (m[i] << 8 | m[i] >>> 24) & 16711935 | (m[i] << 24 | m[i] >>> 8) & 4278255360;
          }
          m[l >>> 5] |= 128 << l % 32;
          m[(l + 64 >>> 9 << 4) + 14] = l;
          var FF = md52._ff, GG = md52._gg, HH = md52._hh, II = md52._ii;
          for (var i = 0; i < m.length; i += 16) {
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
          }
          return crypt.endian([a, b, c, d]);
        };
        md52._ff = function (a, b, c, d, x, s, t) {
          var n = a + (b & c | ~b & d) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };
        md52._gg = function (a, b, c, d, x, s, t) {
          var n = a + (b & d | c & ~d) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };
        md52._hh = function (a, b, c, d, x, s, t) {
          var n = a + (b ^ c ^ d) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };
        md52._ii = function (a, b, c, d, x, s, t) {
          var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };
        md52._blocksize = 16;
        md52._digestsize = 16;
        module.exports = function (message, options) {
          if (message === void 0 || message === null)
            throw new Error("Illegal argument " + message);
          var digestbytes = crypt.wordsToBytes(md52(message, options));
          return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
        };
      })();
    }
  });

  // app/scripts/component/productMetaOptions.js
  var md5 = require_md5();
  window.addEventListener("DOMContentLoaded", (e) => {

    if (performance.navigation.type == 2) {
      let lastOptions = localStorage.getItem("pdpOptionCache");

      if (!lastOptions)
        return;

      setTimeout(() => {
        document.querySelector("product-meta-options")?.loadFromCache();
      }, 300);
    } else {
    }
  });
  window.customElements.define("product-meta-options", class extends HTMLElement {
    constructor() {
      super();
      this.lastOptionCount = this.querySelectorAll(".product-form__option-selector").length;
      const observer = new MutationObserver((mutationList, observer2) => {
        const optionCount = this.querySelectorAll(".product-form__option-selector").length;
        if (this.lastOptionCount == optionCount)
          return;
        this.lastOptionCount = optionCount;
        setTimeout(() => {
          this.reIndexOption();
        }, 50);
      });
      const config = { attributes: false, childList: true, subtree: true };
      observer.observe(this, config);
    }
    connectedCallback() {
      this.addEventListener("variant:changed", this._onVariantChanged.bind(this));
      this.addEventListener("change", this._onChange.bind(this));

      this.reIndexOption();
    }
    get optionList() {
      return [...this.querySelectorAll(".product-form__option-selector")];
    }
    get getParentId() {
      const container = this.closest(".product-form");
      return container.querySelector('[name="id"]').value;
    }
    setOptionByIndex(question, index) {
      const parent = this.closest("product-variants");
      parent.querySelectorAll(".jsOptionTitle .product-form__option-name > span").forEach((i) => {
        if (i.textContent != question)
          return;
        const input = i.closest(".product-form__option-selector").querySelectorAll("input[type=radio]")[index - 1];
        if (input)
          input.checked = true;
      });
    }
    set setOption(value) {
      const parent = this.closest("product-variants");
      const optionEl = Array.from(parent.querySelectorAll("input")).find((item) => item.value.trim() == value);
      if (!optionEl)
        return;
      optionEl.checked = true;
      optionEl.closest("details").open = true;
      if (!optionEl.closest("product-sub-option"))
        return;
      optionEl.closest("product-sub-option").dispatchEvent(new CustomEvent("trigger:change", {
        detail: {
          target: optionEl
        }
      }));
    }
    _onVariantChanged(event) {
      this.updateDiscount();
    }
    _onChange() {

      this.updateDiscount();
      this.changeIndex();
      this.closest("product-variants").dispatchEvent(new Event("pdpVariantOption:changed"));
      this.saveOptions();
      setTimeout(() => {
        this.reIndexOption();
      }, 50);
    }
    getParentQty() {
      const container = this.closest(".product-form");
      return container.querySelector('[name="quantity"]')?.value || 1;
    }
    getBundlePricing(parentVariant) {
      const productMeta = this.closest('.shopify-section')?.querySelector('product-meta');
      const formId = productMeta?.getAttribute("form-id");
      const productVariants = formId ? document.querySelector(`product-variants[form-id="${formId}"]`) : null;
      const isPreBuilt = !!(parentVariant && productVariants?._isQuickShipAnwerSelected(parentVariant));
      const selector = isPreBuilt ? 'input:checked' : 'input:not([data-source*="qs_options"]):checked';
      const inputs = Array.from(this.querySelectorAll(selector));
      const selectedItems = [];
      const autoItems = new Map();

      const itemComparePrice = (input, variant) => {
        const msrp = Number(input?.dataset?.msrpPrice);
        if (Number.isFinite(msrp) && msrp > 0) return msrp;

        const price = Number(variant?.price) || 0;
        const compareAt = Number(variant?.compare_at_price) || 0;
        return compareAt > price ? compareAt : price;
      };

      inputs.forEach((input) => {
        const { source = '', prebuild = '', atc = 'false' } = input.dataset;
        let variant = null;

        try {
          variant = JSON.parse(input.dataset.variant || 'null');
        } catch (error) {
          return;
        }

        if (!variant || (isPreBuilt && prebuild !== '')) return;

        const configuredQty = Number(input.dataset.qty);
        const quantity = Number.isFinite(configuredQty) && configuredQty > 0 ? configuredQty : 1;
        const item = {
          id: variant.id,
          quantity,
          price: Number(variant.price) || 0,
          comparePrice: itemComparePrice(input, variant)
        };

        // Auto-adds carry their own per-build quantity: the `auto_add_to_cart` metafield may list a
        // variant multiple times to mean "add it that many times" (the count arrives via `data-qty`).
        if (source.includes('auto_add_to_cart')) {
          autoItems.set(item.id, item);
          return;
        }

        if (atc === 'true') selectedItems.push(item);
      });

      // A build-your-own custom product rides as the final selected add-on.
      if (!isPreBuilt) {
        try {
          const customProduct = JSON.parse(this.querySelector('variant-addons')?.dataset?.customProduct || 'null');
          if (customProduct) {
            selectedItems.push({
              id: customProduct.id,
              quantity: 1,
              price: Number(customProduct.price) || 0,
              comparePrice: itemComparePrice(null, customProduct)
            });
          }
        } catch (error) {
          // Ignore malformed optional custom-product data, as submit() historically did.
        }
      }

      // Duplicate selected variants combine their quantities; duplicate auto-add keys collapse to
      // one entry (its count is already in `data-qty`).
      const mergedSelectedItems = Array.from(selectedItems.reduce((items, item) => {
        const existing = items.get(item.id);
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          items.set(item.id, { ...item });
        }
        return items;
      }, new Map()).values());
      const allItems = [...mergedSelectedItems, ...autoItems.values()];
      const parentPrice = Number(parentVariant?.price) || 0;
      const discountPercent = isPreBuilt ? Number(parentVariant?.metafields?.boost?.qs_discount) || 0 : 0;
      const discountFactor = discountPercent > 0 ? 1 - discountPercent / 100 : 1;
      const discountedUnitPrice = (price) => Math.round(price * discountFactor);
      const totalPrice = discountedUnitPrice(parentPrice) + allItems.reduce(
        (total, item) => total + discountedUnitPrice(item.price) * item.quantity,
        0
      );
      const parentMsrp = Number(parentVariant?.metafields?.boost?.msrp) || 0;
      const parentComparePrice = parentMsrp > 0
        ? parentMsrp
        : itemComparePrice(null, parentVariant);
      const comparePrice = parentComparePrice + allItems.reduce(
        (total, item) => total + item.comparePrice * item.quantity,
        0
      );

      return {
        inputs,
        isPreBuilt,
        selectedItems: mergedSelectedItems,
        autoItems: Array.from(autoItems.values()),
        totalPrice,
        comparePrice: comparePrice >= totalPrice ? comparePrice : 0
      };
    }
    submit() {
      // Multi-line add-to-cart: the parent carries the config props; every selected/auto-added
      // add-on becomes its own real cart line (Shopify-set price, untamperable), tagged with a
      // shared `_bundle_id`. The Cart Transform `linesMerge`s the group into one native bundle.
      const propertiesArr = {};
      // Placeholder id tying the parent line to its add-on child lines. theme.js replaces this
      // with a deterministic fingerprint of the full configuration before posting, so identical
      // builds share one _bundle_id and Shopify's native cart merge collapses them by quantity.
      const bundleId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `b_${Date.now()}_${Math.floor(Math.random() * 1e9)}`;

      const productMeta = this.closest('.shopify-section').querySelector('product-meta')
      const variantId = productMeta.currentVariant?.id;
      const currentVariant = window.theme.product.variants.find((variant) => variant.id === variantId)
        || productMeta.currentVariant;
      const bundlePricing = this.getBundlePricing(currentVariant);

      if (bundlePricing.isPreBuilt) {
        propertiesArr['_has_qs_discount'] = true;
      }

      return new Promise((resolve, reject) => {
        bundlePricing.inputs.forEach((input) => {
          const { properties = 'false', question } = input.dataset;
          if (properties === 'true') {
            propertiesArr[`Q: ${question}`] = input.value;
          }
        });

        // Child line quantity = per-build quantity × the PDP quantity. The transform derives the
        // bundle count from the GCD of the group's line quantities, so every child must scale with
        // the parent — an unscaled fixed `data-qty` (e.g. 2 per build at PDP qty 3) would merge
        // into one malformed bundle instead of 3 bundles.
        const parentQty = Math.max(1, parseInt(this.getParentQty(), 10) || 1);
        const merged = new Map();
        bundlePricing.selectedItems.concat(bundlePricing.autoItems).forEach((item) => {
          const existing = merged.get(item.id);
          if (existing) {
            existing.quantity += item.quantity * parentQty;
          } else {
            merged.set(item.id, {
              id: item.id,
              quantity: item.quantity * parentQty,
              properties: { _bundle_role: 'child', _bundle_id: bundleId }
            });
          }
        });
        const childItems = Array.from(merged.values());

        // Return the parent config props + the add-on child lines. theme.js posts the parent
        // line plus these children as separate cart lines (all sharing _bundle_id); the Cart
        // Transform merges them into a native bundle and recomputes pricing server-side.
        resolve({
          properties: propertiesArr,
          items: childItems,
          bundleId: childItems.length ? bundleId : null,
        });
      });
    }
    findChildAddCart() {
      if (!document.querySelector(".jsShippingProduct") || !document.querySelector(".jsVariantQuickShip"))
        return null;
      const data = JSON.parse(document.querySelector(".jsVariantQuickShip").textContent);
      const quickShip = data.find((item) => item.id == this.getParentId);
      if (!quickShip)
        return false;
      const currentOptions = Array.from(document.querySelectorAll("product-variants product-meta-options input:checked")).map((item) => {
        return { question: item.dataset.question, answer: item.value };
      });
      return quickShip.quickship.every((item) => {
        return currentOptions.find((i) => i.question == item.question && i.answer == item.answer);
      });
    }
    changeIndex() {
      const listOption = document.querySelectorAll("product-meta-options .product-form__option-index");
      const lastIndex = this.dataset.optionCount;
      listOption.forEach((item, index) => {
        item.innerHTML = index + 1 + +lastIndex;
      });

      const listOption2 = document.querySelectorAll("product-meta-options .product-form__option-selector");
      listOption2.forEach((item, index) => {
        // item.innerHTML = index + 1 + +lastIndex;
        // item.innerHTML = index + 0 + +lastIndex;
        item.classList.add('rq-hide-start' + index + 0 + +lastIndex);
      });
    }
    reIndexOption() {
      this.optionList.forEach((item, index) => {
        item.querySelector(".product-form__option-index").innerHTML = index + 1 + +this.dataset.optionCount;
      });
    }
    async updateDiscount() {
      const getOptionList = () => {
        const totalQuickShip = document.querySelectorAll("product-variants input ~ .quickship__label");
        const quickShipList = document.querySelectorAll("product-variants input:checked ~ .quickship__label");
        return totalQuickShip.length == quickShipList.length ? [...document.querySelectorAll("product-variants input:checked")].map((i) => {
          return i.name + "=" + i.value;
        }) : [];
      };
      const optionList = getOptionList();
      const id = this.getParentId;
      if (!optionList.length) {
        return;
      }
      const url = `${this.dataset.productUrl}&variant=${id}&options=${optionList.join("+")}`;
      this.lastRequest = url;
      const response = await fetch(url);
      let html = await response.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      const price = div.querySelector(".jsProductPrice")?.innerHTML || null;
      this.discountProp = {};
      if (price) {
        this.discountProp = {
          key: `properties[_discountPrice]`,
          value: price
        };
      }


    }
    _checkAllSelected() {
      const arrOption = document.querySelectorAll("product-variants .product-form__option-index");
      const checkedInputs = document.querySelectorAll("product-variants input:checked");
      if (arrOption.length == checkedInputs.length) {
        return true;
      }
      return false;
    }
    /**
     * Restores checked options from a cached selection list on browser back navigation.
     * @param {Array<Record<string, string>>} selectedList
     */
    applySelectedFromCache(selectedList) {
      selectedList.forEach((optionObj) => {
        const entries = Object.entries(optionObj);

        if (!entries.length) {
          return;
        }

        const [name, value] = entries[0];
        const input = Array.from(this.querySelectorAll("input.optionObject-field")).find(
          (el) => el.name === name && el.value.trim() === value.trim()
        );

        if (!input) {
          return;
        }

        input.checked = true;

        const details = input.closest("details");

        if (details) {
          details.open = true;
        }

        const subOption = input.closest("product-sub-option");

        if (subOption) {
          subOption.dispatchEvent(new CustomEvent("trigger:change", {
            detail: {
              target: input
            }
          }));
        }
      });
    }
    /**
     * Persists selected option values for browser-back restoration on the current product.
     */
    saveOptions() {
      const selectedList = [...this.querySelectorAll("input.optionObject-field:checked")].map((input) => ({
        [input.name]: input.value
      }));
      const entry = {
        handle: this.dataset.handle,
        selected: selectedList,
        updatedAt: Date.now()
      };
      const maxCacheEntries = 15;

      try {
        let options = [];
        const cached = window.localStorage.getItem("pdpOptionCache");

        if (cached) {
          options = JSON.parse(cached).filter((item) => item && item.handle);
        }

        const existingIndex = options.findIndex((item) => item.handle === this.dataset.handle);

        if (existingIndex >= 0) {
          options[existingIndex] = entry;
        } else {
          options.push(entry);
        }

        if (options.length > maxCacheEntries) {
          options.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
          options = options.slice(0, maxCacheEntries);
        }

        window.localStorage.setItem("pdpOptionCache", JSON.stringify(options));
      } catch (error) {
        try {
          window.localStorage.removeItem("pdpOptionCache");
          window.localStorage.setItem("pdpOptionCache", JSON.stringify([entry]));
        } catch (retryError) {
          return;
        }
      }
    }
    resetField() {
      let hasReset = false;
      this.querySelectorAll("input:checked")?.forEach((input) => {
        input.checked = false;
        hasReset = true;
      });
      this.querySelectorAll("details[open]")?.forEach((item) => {
        item.open = false;
        hasReset = true;
      });

      hasReset && document.getElementById("AddToCart").setAttribute('disabled', 'disabled');
    }

    loadFromCache() {
      if (performance.navigation.type != 2 || this.isLoadedFromCache == true) return;

      try {
        const options = window.localStorage.getItem("pdpOptionCache");

        if (!options) {
          return;
        }

        const lastOptions = JSON.parse(options).find((item) => item.handle == this.dataset.handle);

        if (!lastOptions) {
          return;
        }

        if (lastOptions.selected?.length) {
          this.applySelectedFromCache(lastOptions.selected);
        } else if (lastOptions.html) {
          this.innerHTML = JSON.parse(lastOptions.html);
        } else {
          return;
        }

        this.dispatchEvent(new CustomEvent("pdpSubOption:changed", { bubbles: true }));

        this._onChange();

        this.isLoadedFromCache = true;
      } catch (error) {
        return;
      }
    }
  });
  window.customElements.define("product-sub-option", class extends HTMLElement {
    connectedCallback() {
      this.answerList = Array.from(this.querySelectorAll(".block-swatch"));
      this.addEventListener("change", this.onChange.bind(this));
      this.addEventListener("trigger:change", (e) => {
        this.onChange(e.detail);
      });
    }
    changeIndex() {
      const listOption = document.querySelectorAll("product-meta-options .product-form__option-index");
      const lastIndex = this.closest("product-meta-options").dataset.optionCount;
      listOption.forEach((item, index) => {
        item.innerHTML = index + 1 + +lastIndex;
      });
    }
    onChange(event) {
      const currentItem = event.target.closest(".block-swatch");
      let currentIndex = -1;
      if (event.target.closest(".sub__option")) {
        const subOptionEl = Array.from(event.target.closest(".sub__option").querySelectorAll(":scope > product-sub-option"));
        if (subOptionEl.length && !subOptionEl.some((i) => i == this)) {
          return;
        }
        if (!event.target.closest(".sub__option").querySelector(":scope > product-sub-option")) {
          this.dispatchEvent(new CustomEvent("pdpSubOption:changed", { bubbles: true }));
          return;
        }
        event.stopPropagation();
        this.closest("product-meta-options").dispatchEvent(new Event("change", { bubbles: true }));
        this.subAnswerList = Array.from(event.target.closest(".jsMetaOption").querySelectorAll(".block-swatch"));
        currentIndex = this.subAnswerList.findIndex((item) => item == currentItem) + 1 + "";
      } else {
        currentIndex = this.answerList.findIndex((item) => item == currentItem) + 1 + "";
      }
      const subOptions = [...this.querySelector("template").content.children].filter((i) => {
        return i.dataset.answer.split(",").includes(currentIndex);
      });
      if (!subOptions.length) {
        this.querySelector(".sub__option").innerHTML = "";
        this.lastHTML = "";
        this.dispatchEvent(new CustomEvent("pdpSubOption:changed", { bubbles: true }));
        return;
      }
      ;
      const newHTML = subOptions.map((i) => i.innerHTML).join("");
      if (newHTML == this.lastHTML) {
        return;
      }
      this.lastHTML = newHTML;
      this.querySelector(".sub__option").innerHTML = newHTML;
      this.dispatchEvent(new CustomEvent("pdpSubOption:changed", { bubbles: true }));
    }
  });
  window.customElements.define("details-tooltip", class extends HTMLDetailsElement {
    connectedCallback() {
      if (window.matchMedia("(min-width: 992px)").matches) {
        this.addEventListener("mouseenter", ((e) => {
          this.setAttribute("open", null);
        }).bind(this));
        this.addEventListener("mouseleave", ((e) => {
          this.removeAttribute("open", false);
        }).bind(this));
      }
      // Prevent click events from bubbling up to avoid triggering collapsible tab handlers
      this.addEventListener("click", ((e) => {
        e.stopPropagation();
      }).bind(this));
    }
  }, { extends: "details" });
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".jsOptionTitle") && !e.target.closest(".product-form__option-tooltip")) {
      const details = e.target.closest(".jsOptionTitle").previousElementSibling;
      if (details.tagName == "DETAILS") {
        details.open = details.open ? false : true;
      }
    }
  });

  // app/scripts/component/productPrice.js
  var productPrice = class extends HTMLElement {
    connectedCallback() {
      this.initPrice = this.innerHTML;
    }
    set(price) {
      const currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
      if (price)
        this.innerHTML = formatMoney(price, currencyFormat);
      else
        this.innerHTML = this.initPrice;
    }
  };
  customElements.define("product-price", productPrice);

  // app/scripts/component/productPopup.js
  var readyMadeOptions = (popup) => {
    const btn = popup.querySelector(".jsReadyMade");
    btn.addEventListener("click", () => {
      btn.closest("modal-content").open = false;
      popup.querySelectorAll(".jsReadyMadeList").forEach((item) => {
        const value = item.textContent.trim();
        document.querySelector("product-meta-options").setOption = value;
      });
      document.querySelector("product-meta-options")._onChange();
      document.querySelector("product-meta-options").closest("product-variants")._onOptionChanged();
      document.querySelectorAll('product-meta-options details:not([class*="tooltip"])').forEach((item) => {
        item.open = true;
      });
    });
  };
  var fetchReadyMadePopup = (e) => {
    const variant = e.detail.variant;
    return new Promise((resolve, reject) => {
      let variantList = document.getElementById("variantQuickShipJSON");
      if (!variant) {
        resolve(true);
        return;
      }
      variantList = JSON.parse(variantList.textContent);
      const object = variantList.find((i) => i.id == variant.id);
      if (!object) {
        resolve(true);
        return;
      }
      window.quickShipFetching = true;
      const url = `${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${variant.id}?section_id=pdp-modal`;
      fetch(url).then((e2) => e2.text()).then((html) => {
        resolve(true);
        let div = document.createElement("div");
        div.innerHTML = html;
        document.querySelectorAll(`#${div.querySelector(":scope > div:first-child").id}`).forEach((item) => {
          item.parentNode.tagName == "DIV" && item.parentNode.remove();
        });
        document.body.appendChild(div);
        if (div.querySelector("modal-content")) {
          div.querySelector("modal-content").open = true;
          readyMadeOptions(div);
        }
      });
    });
  };
  window.addEventListener("variant:quickship", (e) => {
    if (window.quickShipFetching) {
      return;
    }
    fetchReadyMadePopup(e);
  });

  // app/scripts/component/variantMedia.js
  window.customElements.define("variant-media", class extends HTMLElement {
    constructor() {
      super();
      this.cache = [];
      this.addEventListener("variant:changed", this._onVariantChanged.bind(this));
    }
    _onVariantChanged(event) {
      if (!event.detail.variant) {
        this.innerHTML = "";
      } else {
        if (this.timeout != null) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this._renderForVariant(event.detail.variant["id"]);
          this.timeout = null;
        }, 300);
      }
    }
    get optionList() {
      const optionList = document.querySelectorAll("product-variants input:checked");
      return [...optionList].map((i) => {
        return i.name + "=" + i.value;
      });
    }
    async _renderForVariant(id) {
      const url = `${this.dataset.productUrl}&variant=${id}&options=${encodeURIComponent(this.optionList.join("[+]"))}`;
      if (url == this.lastRequest)
        return;
      document.documentElement.dispatchEvent(new Event("theme:loading:start"));
      this.lastRequest = url;
      let data = this.findInCache(url);
      if (!data) {
        const response = await fetch(url);
        let html = await response.text();
        html = html.split("<!-- variantMedia -->");
        data = html[1];
      }
      document.documentElement.dispatchEvent(new Event("theme:loading:end"));
      const newDiv = document.createElement("div");
      newDiv.innerHTML = data;
      if (!newDiv.querySelectorAll(".media-bg").length)
        return;
      this.innerHTML = data;
      newDiv.remove();
      this.cache.push({
        url,
        html: data
      });
    }
    get mediaList() {
      return JSON.parse(this.querySelector('script[type*="json"]')?.textContent || "{}");
    }
    findInCache(url) {
      const data = this.cache?.find((item) => item.url == url);
      return data?.html || null;
    }
  });

  // app/scripts/component/variantOptions.js
  var variantOptions = class extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.addEventListener("variant:changed", this._onVariantChanged.bind(this));
    }
    _onVariantChanged(event) {
      this.selectedVariant = event.detail.variant;
      this.fetch();
    }
    async fetch() {
      const url = this.dataset.url.replace("variantId", this.selectedVariant.id);
      let resp = await fetch(url);
      resp = await resp.text();
      this.innerHTML = resp.split("<!-- /// -->")[1] || "";

      this.closest("product-meta-options")?.reIndexOption();
      this.dispatchEvent(new CustomEvent("pdpVariantOption:changed", { bubbles: true }));

    }
  };
  customElements.define("variant-options", variantOptions);

  // app/scripts/component/msrpPrice.js
  customElements.define("msrp-price", class productPrice2 extends HTMLElement {
    constructor() {
      super();
      this.template = this.querySelector("template").content.cloneNode(true);
      window.addEventListener("variant:changed", this._onVariantChanged.bind(this));
      window.addEventListener("form:filled", this.setPrice.bind(this));
    }
    _onVariantChanged({ detail }) {
      const { variant } = detail;
      this.lastVariant = variant;
      this.setPrice();
    }
    setPrice() {
      if (!this.lastVariant) {
        this.lastVariant = window.theme.product.variants.find((variant) => variant.id == +this.dataset.default);
      }
      this.innerHTML = "";
      this.toggleAttribute("hidden", true);
      this.closest(".shopify-section")?.classList.remove("has-msrp-price");
      const metaOptions = document.querySelector('product-meta-options');
      // variant:changed can carry ProductLoader's lean variant object, which does not include the
      // boost MSRP injected by js-variables.liquid. Resolve the enriched variant so the PDP and
      // the carried cart compare-at use the same parent MSRP.
      const currentVariant = window.theme.product.variants.find(
        (variant) => variant.id === this.lastVariant.id
      ) || this.lastVariant;
      const bundlePricing = metaOptions?.getBundlePricing(currentVariant);
      const price = bundlePricing?.comparePrice || 0;
      if (!price)
        return;
      let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
      let priceHTML = `<span class="price price--compare">${formatMoney(price, currencyFormat)}</span>`;
      this.insertAdjacentHTML("beforeend", priceHTML);
      this.removeAttribute("hidden");
      this.closest(".shopify-section")?.classList.add("has-msrp-price");
    }
  });



  // app/scripts/component/backgroundLazy.js
  var customElementTagName = "background-lazy";
  !window.customElements.get(customElementTagName) && window.customElements.define(customElementTagName, class extends HTMLElement {
    constructor() {
      super();
      if (this.hasAttribute('data-eager')) {
        this.setBackground();
      } else if ("IntersectionObserver" in window) {
        let handleIntersection = function (entries) {
          entries.map((entry) => {
            if (entry.isIntersecting) {
              this.setBackground();
              observer.unobserve(entry.target);
            }
          });
        };
        const observer = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "50px" });
        observer.observe(this);
      } else {
        this.setBackground();
      }
    }
    setBackground() {
      if (document.querySelector(`style[data-uniq*="${this.className}"]`))
        return;
      const styleText = this.style.cssText + `--background-image: ${this.dataset.background};`;
      const styleTag = document.createElement("style");
      styleTag.setAttribute("data-uniq", this.className);
      styleTag.innerHTML = `[class*="${this.className}"]{${styleText}}`;
      document.body.insertAdjacentElement("beforeend", styleTag);
    }
  });

  // Variant addOns
  !window.customElements.get('variant-addons') && window.customElements.define('variant-addons', class extends HTMLElement {
    constructor() {
      super();
      document.querySelector('product-meta-options')?.addEventListener('variant:changed', this.onVariantChanged.bind(this))

      this.content = this.querySelector('.content')
      this.template = this.querySelector('template')

      // Activate the default variant's add-ons on load. Single-variant products never fire
      // `variant:changed`, so without this their auto-add inputs stay inert in the <template>
      // and never reach `submit()` / the cart.
      this.activate(this.dataset.default);
    }
    activate(variantId) {
      if (!variantId || !this.content || !this.template) return;
      const markup = this.template.content.querySelector(`[data-id="${variantId}"]`)?.cloneNode(true).innerHTML || '';
      this.content.innerHTML = markup;
    }
    onVariantChanged(event) {
      const { detail: { variant = null } } = event;
      if (!variant) return;
      this.activate(variant.id);
    }

    get isAllVariantAvailable() {
      return !!this.querySelector('[data-variant-available="false"]');
    }
  });
})();

// app/scripts/component/variant paintable.js
var customElementTagName = "variant-paintable";
!window.customElements.get(customElementTagName) && window.customElements.define(customElementTagName, class extends HTMLElement {
  constructor() {
    super();
    this.template = this.querySelector('template').content.firstElementChild.cloneNode(true);
    this.ids = this.getAttribute("data-ids").split(',');
    this.masterSelector = document.getElementById(this.getAttribute("form-id"));
    this.masterSelector.addEventListener("variant:changed", this._onVariantChanged.bind(this));
    this.cache = new Map();

    document.addEventListener('pdpMetaOption:Changed', this._onVariantChanged.bind(this));
  }

  addEvent() {
    let debounceTimeout;

    this.querySelectorAll('input').forEach(input => {

      input.addEventListener('focusin', (event) => {
        this.currentTarget = input;
      });
      input.addEventListener('keyup', (event) => {
        if (input.id == 'fieldVIN') {
          input.value = input.value.replace(/[^a-zA-Z0-9]/g, '')
        }
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
          this._onChange(event);
        }, 700);
      });

      // Add blur event to validate when user leaves the field
      input.addEventListener('blur', (event) => {
        this._validateField(event.target);
      });

      // Add input event to update is-filled class in real-time
      input.addEventListener('input', (event) => {
        const hasValue = event.target.value.length > 0;
        event.target.classList.toggle('is-filled', hasValue);
      });

      input.id == 'fieldVIN' && input.addEventListener('keydown', (event) => {
        const key = event.key;
        if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key)) {
          return;
        }
        if (!/^[a-zA-Z0-9]$/.test(key)) {
          event.preventDefault();
        }
      });
    })

  }

  _onVariantChanged(event) {
    const hasPaintable = [...this.masterSelector.elements].find(element => element.checked && element.value.toLowerCase().includes('paint') && element.value.toLowerCase().includes('*'))
    const variantInfo = event.detail.variant;
    const lastState = this.saveLastSate;

    if (lastState && lastState == !!hasPaintable) return;

    this.saveLastSate = !!hasPaintable;

    if (!hasPaintable) {
      this.innerHTML = '';
      return;
    }

    this.innerHTML = this.template.outerHTML;

    if (this.cache.size) {
      this.cache.forEach((value, key) => {
        const input = this.querySelector(`input[name="${key}"]`);
        if (input) {
          input.value = value;
          input.classList.add('is-filled');

          // Check validation after loading from cache
          if (input.id === 'fieldVIN') {
            input.classList.toggle('error', value.length < 17);
          }
          if (input.id === 'fieldPC') {
            input.classList.toggle('error', !value);
          }
        }
      });
    }

    this.addEvent();
  }

  _validateField(input) {
    const isVIN = input.id === 'fieldVIN';
    const isPC = input.id === 'fieldPC';

    // Toggle is-filled class based on whether input has a value
    const hasValue = input.value.length > 0;
    input.classList.toggle('is-filled', hasValue);

    if (isVIN) {
      // Only show error if field has been touched (has value) and is invalid
      const isValid = input.value.length === 17;
      input.classList.toggle('error', hasValue && !isValid);
    }

    if (isPC) {
      // Only show error if field has been touched (has value) and is invalid
      input.classList.toggle('error', hasValue && !input.value.trim());
    }
  }

  _onChange(event) {
    const inputs = this.querySelectorAll('input');
    inputs.forEach(input => {
      this.cache.set(input.name, input.value);
    });

    const { target } = event;

    // Validate and update is-filled class
    this._validateField(target);

    if (this.focusOutTimeout != null)
      clearTimeout(this.focusOutTimeout);


    this.focusOutTimeout = setTimeout(() => {
      document.querySelector('.product-form product-variants').dispatchEvent(new CustomEvent('pdpSubOption:changed', {
        detail: {
          type: 'paintableChanged'
        }
      }));

      const inputFocus = [...this.querySelectorAll('input')].find(i => i.id == this.currentTarget.id)
      inputFocus?.focus();

      this.focusOutTimeout = null;
    }, 400);
  }
  get isValid() {
    const fieldVIN = this.querySelector('#fieldVIN');
    const fieldPC = this.querySelector('#fieldPC');

    if (!fieldVIN || !fieldPC) return true;

    return fieldVIN.value.length === 17 && fieldPC.value.length > 0;
  }
});

// Variant Drawer Functionality
class VariantDrawerManager {
  constructor() {
    this.currentVariant = null;
    this.productVariants = [];
    this.init();
  }

  init() {
    // Get product variants from window.theme.product
    if (window.theme && window.theme.product) {
      this.productVariants = window.theme.product.variants || [];
    }

    // Listen for variant changes
    document.addEventListener('variant:changed', this.onVariantChanged.bind(this));

    // Listen for drawer trigger clicks
    document.addEventListener('click', this.onDrawerTriggerClick.bind(this));
  }

  onVariantChanged(event) {
    this.currentVariant = event.detail.variant;
  }

  onDrawerTriggerClick(event) {
    const trigger = event.target.closest('.variant-drawer-trigger');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      // Prefer nearby template content if available
      const template = trigger.parentElement?.querySelector('.variant-drawer-template');
      if (template) {
        const html = template.innerHTML;
        this.openDrawer(html);
        return;
      }
      this.openDrawer();
    }
  }

  async openDrawer(preRenderedHtml = null) {
    const drawer = document.getElementById('variant-drawer');
    if (!drawer) {
      return;
    }

    // Show loading state
    this.showLoading();

    // Open drawer
    drawer.open = true;

    // If HTML is provided, render immediately
    if (preRenderedHtml) {
      this.displayVariantContent({ title: 'Variant Information' }, preRenderedHtml);
      this.showMain();
      this.initVariantCarousels();
      return;
    }

    // Get variant to load content for
    const variant = this.currentVariant || this.productVariants[0];

    if (!variant) {
      this.showEmpty();
      return;
    }

    try {
      await this.loadVariantContent(variant);
      this.initVariantCarousels();
    } catch (error) {
      this.showEmpty();
    }
  }

  showLoading() {
    const loading = document.getElementById('variant-drawer-loading');
    const main = document.getElementById('variant-drawer-main');
    const empty = document.getElementById('variant-drawer-empty');

    if (loading) loading.style.display = 'flex';
    if (main) main.style.display = 'none';
    if (empty) empty.style.display = 'none';
  }

  showMain() {
    const loading = document.getElementById('variant-drawer-loading');
    const main = document.getElementById('variant-drawer-main');
    const empty = document.getElementById('variant-drawer-empty');

    if (loading) loading.style.display = 'none';
    if (main) main.style.display = 'block';
    if (empty) empty.style.display = 'none';
  }

  showEmpty() {
    const loading = document.getElementById('variant-drawer-loading');
    const main = document.getElementById('variant-drawer-main');
    const empty = document.getElementById('variant-drawer-empty');

    if (loading) loading.style.display = 'none';
    if (main) main.style.display = 'none';
    if (empty) empty.style.display = 'flex';
  }

  async loadVariantContent(variant) {
    // Try to get variant metafield content
    const metafieldContent = this.getVariantMetafieldContent(variant);

    if (metafieldContent) {
      this.displayVariantContent(variant, metafieldContent);
      this.showMain();
    } else {
      // If no metafield content, try to fetch from server
      await this.fetchVariantContent(variant);
    }
  }

  getVariantMetafieldContent(variant) {
    // Check for common metafield namespaces and keys
    const metafieldKeys = [
      'custom.variant_info',
      'custom.variant_description',
      'custom.variant_details',
      'custom.variant_content',
      'boost.variant_info',
      'boost.variant_description',
      'boost.variant_details',
      'boost.variant_content'
    ];

    for (const key of metafieldKeys) {
      const [namespace, metafieldKey] = key.split('.');
      if (variant.metafields && variant.metafields[namespace] && variant.metafields[namespace][metafieldKey]) {
        return variant.metafields[namespace][metafieldKey];
      }
    }

    return null;
  }

  async fetchVariantContent(variant) {
    try {
      // Try to fetch variant content from a section or API endpoint
      const response = await fetch(`${window.location.pathname}?variant=${variant.id}&section_id=variant-drawer-content`);
      const html = await response.text();

      // Parse the response to extract content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const content = doc.querySelector('.variant-drawer-content');

      if (content) {
        this.displayVariantContent(variant, content.innerHTML);
        this.showMain();
      } else {
        this.showEmpty();
      }
    } catch (error) {
      this.showEmpty();
    }
  }

  displayVariantContent(variant, content) {
    const titleElement = document.getElementById('variant-drawer-variant-title');
    const contentElement = document.getElementById('variant-drawer-variant-content');

    if (titleElement) {
      titleElement.textContent = variant.title || 'Variant Information';
    }

    if (contentElement) {
      if (typeof content === 'string') {
        contentElement.innerHTML = content;
      } else {
        contentElement.innerHTML = content;
      }
    }
  }
}

// Initialize variant drawer when DOM is ready
function initVariantDrawer() {
  // Initialize variant drawer functionality
  window.variantDrawerManager = new VariantDrawerManager();
}

// Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantDrawer);
} else {
  initVariantDrawer();
}

// Simple carousel for Variant Drawer
function initSingleCarousel(root) {
  try {
    const track = root.querySelector('.variant-carousel__track');
    const slides = Array.from(track.children);
    let index = 0;
    const update = () => {
      const width = root.clientWidth;
      track.style.transform = `translateX(${-index * width}px)`;
    };
    root.querySelector('.variant-carousel__nav.prev')?.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      update();
    });
    root.querySelector('.variant-carousel__nav.next')?.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      update();
    });
    window.addEventListener('resize', update);
    // Basic styles (scoped)
    if (!document.getElementById('variant-carousel-styles')) {
      const style = document.createElement('style');
      style.id = 'variant-carousel-styles';
      style.textContent = `
        .variant-carousel{position:relative;overflow:hidden;margin:12px 0}
        .variant-carousel__track{display:flex;transition:transform .3s ease}
        .variant-carousel__slide{min-width:100%;padding:0 10px;box-sizing:border-box;text-align:center}
        .variant-carousel__slide img{max-width:100%;height:auto}
        .variant-carousel__nav{position:absolute;top:50%;transform:translateY(-50%);background:rgba(0,0,0,.6);color:#fff;border:0;width:36px;height:36px;border-radius:18px;cursor:pointer}
        .variant-carousel__nav.prev{left:6px}
        .variant-carousel__nav.next{right:6px}
      `;
      document.head.appendChild(style);
    }
    update();
  } catch (e) {
  }
}

VariantDrawerManager.prototype.initVariantCarousels = function() {
  document.querySelectorAll('#variant-drawer .variant-carousel').forEach(initSingleCarousel);
}
